import { handleRequest } from './base';

const BatchRepo = {
  create: (batchID, { business, account, description, type }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/batches/${batchID}`;
    const body = {
      description,
      type,
    };

    return handleRequest({
      method: 'put',
      url: endpoint,
      data: body,
    });
  },

  createDebits: (batchID, { business, account, description, csv }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/direct_debits/batches/${batchID}`;

    const formData = new FormData();
    formData.set('csv', new Blob([csv], { type: 'text/csv' }), 'debits.csv');
    formData.set('description', description);

    return handleRequest({
      method: 'post',
      url: endpoint,
      data: formData,
    });
  },

  fetchDebits: ({ id: businessId }, { id: accountId }) => {
    const endpoint = `/business/${businessId}/accounts/${accountId}/direct_debits/batches`;
    return handleRequest({
      method: 'get',
      url: endpoint,
    });
  },

  downloadDebitsFile: async ({ id: businessId }, { id: accountId }, batchId) => {
    const endpoint = `/business/${businessId}/accounts/${accountId}/direct_debits/batches/${batchId}`;

    const data = await handleRequest({
      method: 'get',
      url: endpoint,
    });

    const link = document.createElement('a');
    link.href = window.URL.createObjectURL(new Blob([data.data]), { type: data.headers['content-type'] });
    link.download = `${batchId}.csv`;
    link.setAttribute('target', '_blank');
    link.click();
  },

  addItem: ({ business, account, batchID, item }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/batches/${batchID}/items`;

    return handleRequest({
      method: 'post',
      url: endpoint,
      data: item,
    });
  },

  bulkItems: ({ business, account, batchID, items }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/batches/${batchID}/items/bulk`;

    return handleRequest({
      method: 'post',
      url: endpoint,
      data: items,
    });
  },

  fetch: ({ business, account, batchID }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/batches/${batchID}`;
    return handleRequest({
      method: 'get',
      url: endpoint,
    });
  },

  fetchCollection: ({ id: businessId }, { id: accountId }, params = {}) => {
    const endpoint = `/business/${businessId}/accounts/${accountId}/batches`;
    return handleRequest({
      method: 'get',
      url: endpoint,
      params,
    });
  },

  fetchItems: ({ business, account, batchID }) => {
    const endpoint = `/business/${business.id}/accounts/${account.id}/batches/${batchID}/items`;
    return handleRequest({
      method: 'get',
      url: endpoint,
    });
  },

  cancelBatch: ({ id: businessId }, { id: accountId }, batchId) => {
    const endpoint = `/business/${businessId}/accounts/${accountId}/direct_debits/batches/${batchId}/cancel`;
    return handleRequest({
      method: 'get',
      url: endpoint,
    });
  },

  cancelDebit: ({ id: businessId }, { id: accountId }, debitId) => {
    const endpoint = `/business/${businessId}/accounts/${accountId}/direct_debits/debits/${debitId}`;
    return handleRequest({
      method: 'delete',
      url: endpoint,
    });
  },
};

export default BatchRepo;
